"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForceableErrorCopyKey = exports.mapKapiErrorResponseToSubmitReadError = void 0;
var date_fns_1 = require("date-fns");
var mapKapiReadings_1 = require("./mapKapiReadings");
var forceableErrorCodes = [
    'ILLEGAL_NEGATIVE_CONSUMPTION',
    'CONSUMPTION_TOO_HIGH',
];
var genericError = { errorCode: 'GENERIC' };
var errorCopyKeys = [
    'errorsFallback',
    'errorsServerTooHigh',
    'errorsServerTooHighMultiRate',
    'errorsServerTooLow',
    'errorsServerTooLowMultiRate',
];
var isForceableErrorCode = function (reason) {
    return forceableErrorCodes.includes(reason);
};
var isForceableKapiError = function (error) {
    return error &&
        typeof error.forceable !== 'undefined' &&
        Array.isArray(error.reason);
};
var allGraphQLErrorsExpected = function (errors) {
    return errors.every(function (_a) {
        var path = _a.path, extensions = _a.extensions;
        return path &&
            (path.includes('submitElectricityMeterRead_nextV1') ||
                path.includes('submitGasMeterRead_nextV1')) &&
            isForceableKapiError(extensions.error);
    });
};
var mapKapiErrorToForceableError = function (_a) {
    var reasons = _a.reason;
    return reasons.every(function (reason) { return isForceableErrorCode(reason.reason); })
        ? reasons.map(function (reason) { return ({
            errorCode: reason.reason,
            invalidAgainst: reason.invalidAgainst
                ? (0, mapKapiReadings_1.mapKapiReadToDisplay)(reason.invalidAgainst, 'unspecified')
                : null,
        }); })[0]
        : undefined;
};
var mapKapiErrorResponseToSubmitReadError = function (error) {
    if (error.graphQLErrors.length &&
        allGraphQLErrorsExpected(error.graphQLErrors)) {
        var forceableErrors = error.graphQLErrors
            .map(function (_a) {
            var extensions = _a.extensions;
            return extensions.error;
        })
            .map(mapKapiErrorToForceableError);
        // The UI only handles one error and they are all the same severity so
        // just return the first one.
        var forceableError = forceableErrors.filter(function (error) { return !!(error === null || error === void 0 ? void 0 : error.invalidAgainst); })[0];
        if (forceableError) {
            return forceableError;
        }
    }
    return genericError;
};
exports.mapKapiErrorResponseToSubmitReadError = mapKapiErrorResponseToSubmitReadError;
var getForceableErrorCopyKey = function (forceableError, submissionDateTime) {
    if (forceableError.invalidAgainst) {
        var multiRateKey = forceableError.invalidAgainst.tiers.length > 1 ? 'MultiRate' : '';
        if (forceableError.errorCode === 'CONSUMPTION_TOO_HIGH') {
            return "errorsServerTooHigh".concat(multiRateKey);
        }
        else if (forceableError.errorCode === 'ILLEGAL_NEGATIVE_CONSUMPTION') {
            return (0, date_fns_1.isAfter)(submissionDateTime, forceableError.invalidAgainst.formattedReadingDate)
                ? "errorsServerTooLow".concat(multiRateKey)
                : "errorsServerTooHigh".concat(multiRateKey);
        }
    }
    return 'errorsFallback';
};
exports.getForceableErrorCopyKey = getForceableErrorCopyKey;
